import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { initialState } from "./initialState";

const selectDomain = (state?: RootState) =>
  state?.vehicleStatusesState || initialState;

export const selectVehicleStatusesLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectSearchQuery = createSelector(
  [selectDomain],
  (state) => state.searchQuery
);

export const selectActiveStatusTab = createSelector(
  [selectDomain],
  (state) => state.activeStatusTab
);

export const selectActiveDetailTab = createSelector(
  [selectDomain],
  (state) => state.activeDetailTab
);

export const selectStatCards = createSelector(
  [selectDomain],
  (state) => state.statCards
);

export const selectVehicles = createSelector(
  [selectDomain],
  (state) => state.vehicles
);

export const selectSelectedVehicleId = createSelector(
  [selectDomain],
  (state) => state.selectedVehicleId
);

export const selectSelectedVehicleDetail = createSelector(
  [selectDomain],
  (state) => state.selectedVehicleDetail
);

export const selectProductionTab = createSelector(
  [selectSelectedVehicleDetail],
  (detail) => detail?.production ?? null
);

export const selectWeightsTab = createSelector(
  [selectSelectedVehicleDetail],
  (detail) => detail?.weights ?? null
);

export const selectTestsTab = createSelector(
  [selectSelectedVehicleDetail],
  (detail) => detail?.tests ?? null
);

export const selectNotesTab = createSelector(
  [selectSelectedVehicleDetail],
  (detail) => detail?.notes ?? null
);

export const selectDetailsTab = createSelector(
  [selectSelectedVehicleDetail],
  (detail) => detail?.sections ?? null
);
